export default __webpack_public_path__ + "static/crown-profile-transparent-ca207ec495fc8656e71f15d54b8ce90a.png";